import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MessageSquare, Send } from 'lucide-react';
import LegalPageLayout from '../componnents/LegalPageLayout/LegalPageLayout';
import LegalSection from '../componnents/LegalPageLayout/LegalSection';
import LegalContactBlock, {
  SUPPORT_EMAIL,
} from '../componnents/LegalPageLayout/LegalContactBlock';

const Feedback = () => {
  const { t } = useTranslation('feedback');
  const [type, setType] = useState('bug');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [sent, setSent] = useState(false);

  const resetForm = () => {
    setSent(false);
    setMessage('');
    setEmail('');
    setType('bug');
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const subject = encodeURIComponent(
      `[${type === 'bug' ? t('types.bug') : t('types.suggestion')}] St Cael Vog`
    );
    const body = encodeURIComponent(
      `${email ? `Email: ${email}\n\n` : ''}${message.trim()}`
    );
    window.location.href = `mailto:${SUPPORT_EMAIL}?subject=${subject}&body=${body}`;
    setSent(true);
  };

  return (
    <LegalPageLayout
      icon={MessageSquare}
      title={t('title')}
      subtitle={t('subtitle')}
      backLabel={t('backToHome')}
    >
      {sent ? (
        <>
          <LegalSection>
            <p>{t('successIntro')}</p>
          </LegalSection>
          <LegalContactBlock
            title={t('contactTitle')}
            description={t('mailClientHint')}
          />
          <LegalSection>
            <p>
              <button type="button" className="legal-text-link" onClick={resetForm}>
                {t('sendAnother')}
              </button>
            </p>
          </LegalSection>
        </>
      ) : (
        <form onSubmit={handleSubmit} className="legal-form">
          <LegalSection>
            <p>{t('intro')}</p>
          </LegalSection>

          <LegalSection title={t('typeLabel')}>
            <ul className="legal-choice-list">
              <li>
                <label className="legal-radio-line">
                  <input
                    type="radio"
                    name="feedback-type"
                    value="bug"
                    checked={type === 'bug'}
                    onChange={() => setType('bug')}
                  />
                  {t('types.bug')}
                </label>
              </li>
              <li>
                <label className="legal-radio-line">
                  <input
                    type="radio"
                    name="feedback-type"
                    value="suggestion"
                    checked={type === 'suggestion'}
                    onChange={() => setType('suggestion')}
                  />
                  {t('types.suggestion')}
                </label>
              </li>
            </ul>
          </LegalSection>

          <LegalSection title={t('emailLabel')}>
            <p>{t('emailHint')}</p>
            <input
              id="feedback-email"
              type="email"
              className="legal-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={t('emailPlaceholder')}
            />
          </LegalSection>

          <LegalSection title={t('messageLabel')}>
            <p>{t('messageHint')}</p>
            <textarea
              id="feedback-message"
              required
              rows={6}
              className="legal-input legal-textarea"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder={t('messagePlaceholder')}
            />
          </LegalSection>

          <LegalContactBlock
            title={t('submitTitle')}
            description={t('note')}
            action={
              <button type="submit" className="legal-contact-btn legal-submit-btn">
                <Send size={18} />
                {t('submit')}
              </button>
            }
          />
        </form>
      )}
    </LegalPageLayout>
  );
};

export default Feedback;
